// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2iA4K","title":"InfoRow_title__2gnCJ"};